import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';

const awsConfig = {
  Auth: {
    region: 'af-south-1',
    userPoolId: 'af-south-1_f7ZU1gl3H',
    userPoolWebClientId: '6se0c9olt3bjubfb9ft7v8mqp9',
  },
  API: {
    endpoints: [
      {
        name: 'TransportAPI',
        endpoint: 'https://nwmmpkijbk.execute-api.af-south-1.amazonaws.com/prod/',
        region: 'af-south-1',
      },
    ],
  },
};

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);